// L'EFFACEUR — Page de vérification email (atterrissage du lien)

import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';
import { CheckCircle, AlertCircle, Loader2 } from 'lucide-react';
import { API } from '../App';

const VerifyEmailPage = () => {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Lien invalide. Aucun token trouvé.');
      return;
    }

    (async () => {
      try {
        const res = await axios.get(`${API}/security/verify-email`, { params: { token } });
        setStatus('success');
        setEmail(res.data.email || '');
      } catch (e) {
        setStatus('error');
        setMessage(e.response?.data?.detail || 'Erreur de vérification');
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-[#0A0F1F] via-[#0A0F1F] to-[#1a1f3f]">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="glass-card border border-cyan-400/40 p-8 max-w-md w-full text-center"
      >
        {status === 'loading' && (
          <>
            <Loader2 className="w-16 h-16 text-cyan-400 mx-auto mb-4 animate-spin" />
            <h1 className="font-orbitron text-2xl font-bold text-white mb-2">Vérification en cours</h1>
            <p className="text-gray-400 text-sm">Validation de ton adresse email...</p>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle className="w-16 h-16 text-success mx-auto mb-4" />
            <h1 className="font-orbitron text-2xl font-bold text-white mb-2">Email confirmé</h1>
            <p className="text-gray-400 text-sm mb-6">
              {email ? <>Ton email <span className="text-cyan-400 font-mono">{email}</span> est confirmé.</> : 'Ton email est confirmé.'}
              <br />
              Tu reçois maintenant les notifications de mission.
            </p>
            <Link
              to="/dashboard"
              className="inline-block bg-cyan-400 text-black hover:bg-cyan-300 font-bold px-6 py-3 rounded transition-colors"
            >
              Retour au dashboard
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <AlertCircle className="w-16 h-16 text-red-400 mx-auto mb-4" />
            <h1 className="font-orbitron text-2xl font-bold text-white mb-2">Vérification impossible</h1>
            <p className="text-gray-400 text-sm mb-6">{message}</p>
            <div className="flex flex-col gap-2">
              <Link
                to="/dashboard"
                className="inline-block bg-cyan-400 text-black hover:bg-cyan-300 font-bold px-6 py-3 rounded transition-colors"
              >
                Retour au dashboard
              </Link>
              <p className="text-xs text-gray-500 mt-2">
                Tu peux demander un nouveau lien depuis ton dashboard.
              </p>
            </div>
          </>
        )}
      </motion.div>
    </div>
  );
};

export default VerifyEmailPage;
